
import {Vue} from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {useRoute, useRouter} from 'vue-router';
import {RestService} from '../service/rest.service';

export default class HubEventDetailView extends Vue {

  router = useRouter()
  route = useRoute()

  restService = new RestService('hub/events')

  id: string = this.route.params.id as string
  item: any = null

  mounted() {
    this.fetchData(this.id)
  }

  @Watch('route.params.id')
  fetchData(id: string) {
    console.log(id);
    this.restService.get(id)
        .then((data) => this.item = data)
        .catch(() => this.router.push('/404'))
  }

}
